"use client";

type UsernameWithCrownProps = {
  username?: string | null;
  isAdmin?: boolean;
  fallback?: string;
  className?: string;
};

export default function UsernameWithCrown({
  username,
  isAdmin = false,
  fallback = "unknown",
  className = "",
}: UsernameWithCrownProps) {
  const label = username?.trim() || fallback;

  return (
    <span className={`username-with-crown${className ? ` ${className}` : ""}`}>
      <span>{label}</span>
      {isAdmin && (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="admin-crown">
          <path
            d="M12 2.7c2.1 1.78 5.34 2.52 8.43 2.6c.13 4.93-.38 10.92-2.83 14.3c-1.5 2.07-3.41 3.42-5.6 4.7c-2.19-1.28-4.1-2.63-5.6-4.7C3.95 16.22 3.44 10.23 3.57 5.3c3.09-.08 6.33-.82 8.43-2.6Z"
            fill="#74747c"
          />
          <path
            d="M12 4.55c1.66 1.22 4.16 1.82 6.55 1.97c.04 4.12-.43 9.03-2.43 11.8c-1.05 1.45-2.36 2.46-4.12 3.55Z"
            fill="#2a2a2f"
          />
          <path
            d="M12 4.55c-1.66 1.22-4.16 1.82-6.55 1.97c-.04 4.12.43 9.03 2.43 11.8c1.05 1.45 2.36 2.46 4.12 3.55Z"
            fill="#9a9aa3"
          />
        </svg>
      )}
    </span>
  );
}
